var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    viewBox: "0 0 15 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.15625 9.80893L0.830016 7.27927L5.54638 4.59473V7.9504L0.15625 11.3061V9.80893Z",
    fill: "#1C60DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.38379 9.9116L7.67026 6.65918V9.29209C7.67026 9.29209 7.56661 10.1697 7.20381 10.3246C6.89284 10.4279 2.38379 13.1124 2.38379 13.1124V9.9116Z",
    fill: "#1C60DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23438 11.4608L9.95074 8.72461V11.4091C9.95074 11.4091 9.95074 12.1319 9.48429 12.39C9.17332 12.5449 5.23438 14.8164 5.23438 14.8164V11.4608Z",
    fill: "#1C60DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2041 3.61394L9.79551 1.96191V5.31759L7.2041 6.86636V3.61394Z",
    fill: "#1C60DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.27734 5.62703L11.8688 4.12988V7.64043L9.27734 9.13758V5.62703Z",
    fill: "#1C60DD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2988 1.08414L13.061 0V2.32316C13.061 2.32316 13.061 3.51055 12.5945 3.71705C12.4909 3.76868 11.2988 4.43982 11.2988 4.43982V1.08414Z",
    fill: "#1C60DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3507 7.89873L13.1128 6.86621L13.061 9.55075C13.061 9.55075 13.1128 10.2735 12.5945 10.5833C12.4909 10.6865 11.2988 11.2544 11.2988 11.2544C11.2988 11.2544 11.3507 7.79547 11.3507 7.89873Z",
    fill: "#1C60DD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4239 3.25251L14.8233 2.32324C14.8233 2.32324 14.8233 3.71714 14.8233 4.6464C14.8233 4.95616 14.7714 5.21428 14.6159 5.47241C14.5123 5.73054 14.305 5.98867 14.0977 6.14355L13.3721 6.60818C13.4239 6.6598 13.4239 3.25251 13.4239 3.25251Z",
    fill: "#1C60DD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49455 4.59473C5.49455 4.64635 1.19281 6.76301 0.519047 7.48577C0.830016 7.22764 0.259906 7.7439 0.15625 8.56991L0.363563 16.3654C0.363563 16.3654 0.0525936 17.3979 1.65927 18.3272C2.79949 18.9983 9.48532 23.0251 10.2627 23.3865C11.092 23.7479 11.2993 23.18 11.2993 23.18V15.591C11.2993 15.591 11.5584 14.4036 10.1591 13.526C9.89995 13.3195 1.24464 9.39592 0.881845 8.20853C0.519047 6.86626 5.49455 4.90448 5.49455 4.59473Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9361 15.5392L11.3507 15.2295V23.2831C11.3507 23.2831 11.1434 23.6961 10.9361 23.7477C10.8843 23.7477 10.9361 15.5392 10.9361 15.5392Z",
    fill: "#C0C9D7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.621868 8.46692C0.673696 8.57017 0.725524 8.67342 0.829181 8.72505C0.725524 8.6218 0.673696 8.51855 0.621868 8.46692C0.103586 7.12465 3.78339 5.67913 5.33823 4.69824C5.33823 4.69824 1.6066 6.50514 0.881009 7.17628C0.207242 7.74416 0.207242 8.10554 0.207242 8.10554L0.0517578 8.51855C0.0517578 8.31204 0.0517578 8.10554 0.155414 8.05392C0.155414 8.10554 0.621868 8.36367 0.621868 8.46692Z",
    fill: "#1C60DD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79542 13.8356C9.48445 13.5775 5.64917 11.8222 2.9541 10.2734C3.10959 10.3767 3.26507 10.4799 3.36873 10.5316L9.69176 23.1283C9.84725 23.1799 9.95091 23.2315 10.0027 23.2831L10.9356 23.7478V15.6425C10.8838 15.6425 11.0393 14.5067 9.79542 13.8356Z",
    fill: "#1C60DD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0.362727 17.398C0.207242 17.0883 0.103586 16.7785 0.0517578 16.4688C0.0517578 16.8301 0.155414 17.1399 0.362727 17.398Z",
    fill: "url(#paint0_linear_3_10930)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.95414 10.2735C2.02123 9.7056 1.24381 9.18935 0.82918 8.72471C0.777352 8.62146 0.673696 8.56984 0.621868 8.46658C0.621868 8.41496 0.155414 8.05358 0.155414 8.00195C0.103586 8.05358 0.0517578 8.26008 0.0517578 8.51821V16.4686C0.103586 17.0365 0.155414 17.0881 0.310899 17.3978C0.57004 17.7592 0.673696 17.9141 1.08832 18.2755C2.07306 18.8434 8.0333 22.2507 9.6918 23.1283L3.36876 10.5316L2.95414 10.2735Z",
    fill: "#1C60DD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2.90238 10.2735C1.96947 9.7056 1.19205 9.18935 0.777423 8.72471C0.725595 8.62146 0.621938 8.56984 0.57011 8.46658C0.57011 8.41496 0.103656 8.05358 0.103656 8.00195C0.0518282 8.05358 0 8.36333 0 8.56984L0.0518282 16.5202C0.0518282 17.0365 0.155485 17.1397 0.310969 17.4495C0.518282 17.8108 0.777423 18.0174 1.08839 18.2755C2.07313 18.8434 8.03337 22.2507 9.69187 23.1283L3.317 10.5316L2.90238 10.2735Z",
    fill: "url(#paint1_linear_3_10930)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53635 17.14L8.24064 16.314C7.9815 16.1591 7.77419 16.2624 7.87785 16.5205V18.6888C7.92967 18.792 8.03333 19.0501 7.9815 19.1534C7.77419 19.1534 8.7071 19.9278 9.27721 20.2375C9.43269 20.3408 9.74366 20.3408 9.69183 20.031V17.4497C9.69183 17.3981 9.69183 17.3465 9.64 17.2949C9.64 17.1916 9.58817 17.14 9.53635 17.14Z",
    fill: "#B0B5BE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.48467 17.2434C9.27736 16.9853 8.60359 16.6239 8.13714 16.2625C8.03348 16.1592 7.82617 16.2625 7.82617 16.3657C7.878 18.0178 7.878 18.7405 7.98166 19.0503C8.03348 19.3084 8.81091 19.8247 9.27736 20.0828C9.43285 20.1861 9.58833 20.1861 9.58833 20.0312C9.58833 19.36 9.58833 17.7596 9.58833 17.3466C9.5365 17.3466 9.5365 17.295 9.48467 17.2434Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_10930",
    x1: 4.36889,
    y1: 12.1277,
    x2: 0.261389,
    y2: 16.9041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C60DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_10930",
    x1: 6.38585,
    y1: 13.8613,
    x2: 2.27857,
    y2: 18.6385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C60DD",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinIcon);
export default __webpack_public_path__ + "static/media/coin_icon.6c7b178162f9dc378421138e7b7f08d5.svg";
export { ForwardRef as ReactComponent };